import { prop } from 'ramda';

import { FR, EN } from './i18n';

const toTrackingEnv = {
  dev: 'development',
  preprod: 'preproduction',
  recette: 'recette',
  prod: 'production',
};

const toTrackingLang = {
  [FR]: 'FR',
  [EN]: 'EN',
};

export const getTrackingEnv = () => {
  /* istanbul ignore else  */
  if (process.env.RAZZLE_GTM_TRACKING !== 'true') {
    return toTrackingEnv.dev;
  }
  /* istanbul ignore next */
  return prop(process.env.RAZZLE_ENV, toTrackingEnv);
};

export const getTrackingLang = (lang) => prop(lang, toTrackingLang);

export const trackPageLoad = (event, lang) => {
  dataLayer?.push({
    event: 'pageLoad',
    environnement: getTrackingEnv(),
    country: getTrackingLang(lang),
    ...event,
  });
};

export const trackInteraction = (event) =>
  dataLayer?.push({
    event: 'interactionDone',
    environnement: getTrackingEnv(),
    ...event,
  });
